/* USERS */
const actionTypes = Object.freeze({
    CLEAR_STATE: 'USERS/CLEAR_STATE',

    GET_USERS: 'USERS/GET_USERS',
    GET_USERS_SUCCESS: 'USERS/GET_USERS_SUCCESS',
    GET_USERS_FAILED: 'USERS/GET_USERS_FAILED',

    // Optimistic per-row flag changes (active / approved) from the lists
    // and the detail header: the row flips at once, the global loader stays off.
    PATCH_USER_ROW: 'USERS/PATCH_USER_ROW',
    PATCH_USER_ROW_SUCCESS: 'USERS/PATCH_USER_ROW_SUCCESS',
    PATCH_USER_ROW_FAILED: 'USERS/PATCH_USER_ROW_FAILED',

    GET_USER: 'USERS/GET_USER',
    GET_USER_SUCCESS: 'USERS/GET_USER_SUCCESS',
    GET_USER_FAILED: 'USERS/GET_USER_FAILED',

    POST_USER: 'USERS/POST_USER',
    POST_USER_SUCCESS: 'USERS/POST_USER_SUCCESS',
    POST_USER_FAILED: 'USERS/POST_USER_FAILED',

    PATCH_USER: 'USERS/PATCH_USER',
    PATCH_USER_SUCCESS: 'USERS/PATCH_USER_SUCCESS',
    PATCH_USER_FAILED: 'USERS/PATCH_USER_FAILED',

    PATCH_USER_POLICIY: 'USERS/PATCH_USER_POLICY',
    PATCH_USER_POLICIY_SUCCESS: 'USERS/PATCH_USER_POLICY_SUCCESS',
    PATCH_USER_POLICIY_FAILED: 'USERS/PATCH_USER_POLICY_FAILED',

    POST_USER_POLICIY: 'USERS/POST_USER_POLICY',
    POST_USER_POLICIY_SUCCESS: 'USERS/POST_USER_POLICY_SUCCESS',
    POST_USER_POLICIY_FAILED: 'USERS/POST_USER_POLICY_FAILED',

    GET_NEW_AVATAR: 'USERS/GET_NEW_AVATAR',

    GET_CONTACT: 'USERS/GET_CONTACT',
    GET_CONTACT_SUCCESS: 'USERS/GET_CONTACT_SUCCESS',
    GET_CONTACT_FAILED: 'USERS/GET_CONTACT_FAILED',

    POST_CONTACT: 'USERS/POST_CONTACT',
    POST_CONTACT_SUCCESS: 'USERS/POST_CONTACT_SUCCESS',
    POST_CONTACT_FAILED: 'USERS/POST_CONTACT_FAILED',

    PUT_CONTACT: 'USERS/PUT_CONTACT',
    PUT_CONTACT_SUCCESS: 'USERS/PUT_CONTACT_SUCCESS',
    PUT_CONTACT_FAILED: 'USERS/PUT_CONTACT_FAILED',

    POST_FINANCIAL_DETAILS: 'USERS/POST_FINANCIAL_DETAILS',
    POST_FINANCIAL_DETAILS_SUCCESS: 'USERS/POST_FINANCIAL_DETAILS_SUCCESS',
    POST_FINANCIAL_DETAILS_FAILED: 'USERS/POST_FINANCIAL_DETAILS_FAILED',

    PUT_FINANCIAL_DETAILS: 'USERS/PUT_FINANCIAL_DETAILS',
    PUT_FINANCIAL_DETAILS_SUCCESS: 'USERS/PUT_FINANCIAL_DETAILS_SUCCESS',
    PUT_FINANCIAL_DETAILS_FAILED: 'USERS/PUT_FINANCIAL_DETAILS_FAILED',

    GET_POLICIES: 'POLICIES/GET_POLICIES',
    GET_POLICIES_SUCCESS: 'POLICIES/GET_POLICIES_SUCCESS',
    GET_POLICIES_FAILED: 'POLICIES/GET_POLICIES_FAILED',

    GET_MANUFACTURING_POLICY_TYPES: 'USERS/GET_MANUFACTURING_POLICY_TYPES',

    GET_PERSONAL_DISCOUNT: 'USERS/GET_PERSONAL_DISCOUNT',
    GET_PERSONAL_DISCOUNT_SUCCESS: 'USERS/GET_PERSONAL_DISCOUNT_SUCCESS',
    GET_PERSONAL_DISCOUNT_FAILED: 'USERS/GET_PERSONAL_DISCOUNT_FAILED',

    POST_PERSONAL_DISCOUNT: 'USERS/POST_PERSONAL_DISCOUNT',
    POST_PERSONAL_DISCOUNT_SUCCESS: 'USERS/POST_PERSONAL_DISCOUNT_SUCCESS',
    POST_PERSONAL_DISCOUNT_FAILED: 'USERS/POST_PERSONAL_DISCOUNT_FAILED',

    PATCH_PERSONAL_DISCOUNT: 'USERS/PATCH_PERSONAL_DISCOUNT',
    PATCH_PERSONAL_DISCOUNT_SUCCESS: 'USERS/PATCH_PERSONAL_DISCOUNT_SUCCESS',
    PATCH_PERSONAL_DISCOUNT_FAILED: 'USERS/PATCH_PERSONAL_DISCOUNT_FAILED',

    GET_PERSONAL_DISCOUNTS: 'USERS/GET_PERSONAL_DISCOUNTS',
    GET_PERSONAL_DISCOUNTS_SUCCESS: 'USERS/GET_PERSONAL_DISCOUNTS_SUCCESS',
    GET_PERSONAL_DISCOUNTS_FAILED: 'USERS/GET_PERSONAL_DISCOUNTS_FAILED',

    DELETE_PERSONAL_DISCOUNT: 'USERS/DELETE_PERSONAL_DISCOUNT',
    DELETE_PERSONAL_DISCOUNT_SUCCESS: 'USERS/DELETE_PERSONAL_DISCOUNT_SUCCESS',
    DELETE_PERSONAL_DISCOUNT_FAILED: 'USERS/DELETE_PERSONAL_DISCOUNT_FAILED',
});

export default actionTypes;
